/** API route map: URLS.Controller.PayrollSchedule */
export const PayrollSchedule = {
      Name: 'PayrollScheduleSetup/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      Import: 'import',
};
